import React from 'react';
import styles from './index.module.scss';

import Flex from '../Flex';
import If from 'utils/If';

/**
 * @param {object} props
 * @param {'outline' | 'solid'} [props.type='outline']
 * @param {import('utils/types').Size} [props.size='md']
 * @param {import('utils/types').BadgeVariant} [props.variant='light']
 * @param {boolean} [props.indicator=false]
 * @param {React.ReactNode} [props.children=null]
 */
export default function Badge({
  size = 'md',
  type = 'outline',
  variant = 'light',
  indicator = false,
  children = null,
}) {
  const isIndicatorVisible = indicator && type === 'outline';
  return (
    <Flex
      inline
      gap={4}
      align="center"
      justify="center"
      data-size={size}
      data-type={type}
      data-variant={variant}
      className={styles.badge}
    >
      <If test={isIndicatorVisible}>
        <Flex inline className={styles.indicator}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={6}
            height={6}
            viewBox="0 0 6 6"
            fill="none"
          >
            <path
              d="M5.125 5.125C4.54167 5.70833 3.83333 6 3 6C2.16667 6 1.45833 5.70833 0.875 5.125C0.291667 4.54167 0 3.83333 0 3C0 2.16667 0.291667 1.45833 0.875 0.875C1.45833 0.291667 2.16667 0 3 0C3.83333 0 4.54167 0.291667 5.125 0.875C5.70833 1.45833 6 2.16667 6 3C6 3.83333 5.70833 4.54167 5.125 5.125Z"
              fill="currentColor"
            />
          </svg>
        </Flex>
      </If>
      {children}
    </Flex>
  );
}
